export const phoneMask = {
  AR: '(..) ........',
  AM: '.. ......',
  AU: '(..) .... ....',
  AZ: '(..) ... .. ..',
  BY: '(..) ... .. ..',
  BE: '... .. .. ..',
  BR: '(..) .........',
  CA: '(...) ...-....',
  CN: '..-.........',
  CO: '... ... ....',
  CR: '....-....',
  CI: '.. .. .. ..',
  CY: '.. ......',
  CZ: '... ... ...',
  DK: '.. .. .. ..',
  SV: '....-....',
  EE: '.... ......',
  FI: '.. ... .. ..',
  FR: '. .. .. .. ..',
  DE: '.... ........',
  GT: '....-....',
  HT: '....-....',
  HK: '.... ....',
  IS: '... ....',
  IN: '.....-.....',
  IR: '... ... ....',
  IE: '.. .......',
  IL: '... ... ....',
  IT: '... .......',
  JP: '.. .... ....',
  KZ: '... ...-..-..',
  KG: '... ... ...',
  LV: '.. ... ...',
  MY: '..-....-....',
  MX: '... ... ....',
  MD: '(..) ..-..-..',
  NL: '.. ........',
  NZ: '...-...-....',
  NO: '... .. ...',
  PK: '...-.......',
  PH: '.... .......',
  PL: '...-...-...',
  RU: '(...) ...-..-..',
  SG: '....-....',
  KR: '... .... ....',
  ES: '... ... ...',
  SE: '(...) ...-...',
  CH: '.. ... .. ..',
  TR: '... ... .. ..',
  UA: '(..) ... .. ..',
  GB: '.... ......',
  US: '(...) ...-....',
  UZ: '.. ... .. ..',
  VA: '.. .... ....',
};
